import { Component, Prop, Vue } from "vue-property-decorator";
import SaveUser from "@/modules/User/components/SaveUser/SaveUser.vue";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  EDIT_PATIENT_LABELS,
  EMIT_ACTIONS
} from "./constants/EditPatientConstants";

@Component({
  name: "EditPatient",
  components: {
    SaveUser
  }
})
export default class EditPatient extends Vue {
  @Prop({ default: false }) showModal?: boolean;
  @Prop({ default: false }) disabledFieldsProp?: boolean;
  @Prop({ default: "" }) patientName?: string;
  @Prop() userIdProp!: string;

  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  secondaryBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  switchClass = STYLE_CLASSES.SWITCH;
  cardClass = STYLE_CLASSES.CARD;
  SAVE_BTN_LABEL = EDIT_PATIENT_LABELS.SAVE_CHANGES;
  CANCEL_BTN_LABEL = EDIT_PATIENT_LABELS.CANCEL;

  enableEdit = false;

  async closeModal(refresUserData = true) {
    this.enableEdit = false;
    this.$emit(EMIT_ACTIONS.CLOSE_MODAL, refresUserData);
  }

  updateUser() {
    (this.$refs.saveUserComponent as Vue & {
      saveUserModal: () => void;
    }).saveUserModal();
  }
}
